var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDeleteIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 16,
    viewBox: "0 0 15 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.30664 3.8125H2.70291H13.873",
    stroke: "black",
    strokeWidth: 1.2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M12.477 3.81231V13.5862C12.477 13.9565 12.3299 14.3116 12.068 14.5735C11.8062 14.8353 11.451 14.9824 11.0807 14.9824H4.09939C3.72908 14.9824 3.37393 14.8353 3.11208 14.5735C2.85023 14.3116 2.70313 13.9565 2.70312 13.5862V3.81231M4.79753 3.81231V2.41604C4.79753 2.04573 4.94463 1.69058 5.20648 1.42873C5.46833 1.16688 5.82348 1.01978 6.19379 1.01978H8.98633C9.35664 1.01978 9.71179 1.16688 9.97364 1.42873C10.2355 1.69058 10.3826 2.04573 10.3826 2.41604V3.81231",
    stroke: "black",
    strokeWidth: 1.2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M6.19336 7.30298V11.4918",
    stroke: "black",
    strokeWidth: 1.2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M8.98633 7.30298V11.4918",
    stroke: "black",
    strokeWidth: 1.2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDeleteIcon);
export default __webpack_public_path__ + "static/media/delete_icon.6f90e1f6c72be1b36868ed10d921116d.svg";
export { ForwardRef as ReactComponent };